import React, { useState } from "react";
import i18next from '../i18n';
const Donation = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const stripeUrl = "https://donate.stripe.com/00w5kC0YocK42CM1AkcEw07";
    const qrImageUrl = "/stripe_qr.png";

    const styles = {
        page: {
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            padding: "24px",
            boxSizing: "border-box",
        },
        card: {
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
            maxWidth: "420px",
            width: "100%",
            padding: "24px",
            textAlign: "center",
            boxSizing: "border-box",
        },
        title: {
            fontSize: "22px",
            fontWeight: "700",
            marginBottom: "8px",
        },
        description: {
            color: "#666",
            fontSize: "14px",
            marginBottom: "20px",
            lineHeight: 1.6,
        },
        qrWrapper: {
            display: "flex",
            justifyContent: "center",
            marginBottom: "12px",
        },
        qrImage: {
            width: "180px",
            height: "180px",
            objectFit: "contain",
        },
        note: {
            fontSize: "12px",
            color: "#888",
            marginBottom: "20px",
        },
        button: {
            display: "inline-block",
            width: "100%",
            backgroundColor: "#635bff",
            color: "#fff",
            textDecoration: "none",
            fontWeight: "600",
            padding: "14px 0",
            borderRadius: "12px",
            transition: "opacity 0.2s",
            cursor: "pointer",
        },
        before_button: {
            display: "inline-block",
            //width: "10%",
            backgroundColor: "#635bff",
            color: "#fff",
            textDecoration: "none",
            fontWeight: "600",
            padding: "14px 0",
            borderRadius: "12px",
            transition: "opacity 0.2s",
            cursor: "pointer",
        },
        modalOverlay: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
        },
        modalContent: {
            backgroundColor: "#fff",
            borderRadius: "16px",
            padding: "24px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        },
        closeButton: {
            marginTop: "20px",
            backgroundColor: "#b2f2a7ff",
            border: "none",
            borderRadius: "8px",
            padding: "10px 20px",
            cursor: "pointer",
            fontWeight: "600",
        },
    };

    return (
        <div >
            <div
                style={{
                    backgroundColor: 'cadetblue',
                    borderRadius: '20px',
                    width: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems:'center'
                }}
            >
                <p
                style={{
                    fontSize:'18px'
                }}
                >
                    {i18next.t('backup_me')}
                </p>
               

                <button style={styles.before_button} onClick={() => setIsModalOpen(true)}>
                    {i18next.t('donaton')}
                </button>

                {isModalOpen && (
                    <div style={styles.modalOverlay} onClick={() => setIsModalOpen(false)}>
                        <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
                            <p
                                style={{ whiteSpace: 'pre-line' }}
                            >
                                {i18next.t('server_cost')}
                            </p>
                            <div style={styles.qrWrapper}>
                                <img src={qrImageUrl} alt="Stripe Donation QR" style={styles.qrImage} />
                            </div>
                            <div style={styles.note}> {i18next.t('donaton_qr')}</div>
                            <a
                                href={stripeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={styles.button}
                            >
                                {i18next.t('donaton_online')}
                            </a>
                            <button style={styles.closeButton} onClick={() => setIsModalOpen(false)}>
                                {i18next.t('close')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Donation;